// frontend/src/api/fees.js

import { API_BASE_URL, getAuthHeaders } from './config'

/**
 * GET /fees
 */
export async function getFees() {
  const res = await fetch(`${API_BASE_URL}/api/fees`, {
    headers: {
      ...getAuthHeaders()
    }
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch fees: ${res.status}`)
  }
  return res.json()
}

/**
 * POST /fees
 * feeData: { name, display_name, amount, enabled, fee_type }
 */
export async function createFee(feeData) {
  const res = await fetch(`${API_BASE_URL}/api/fees`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify({ fee: feeData })
  })
  if (!res.ok) {
    throw new Error(`Failed to create fee: ${res.status}`)
  }
  return res.json()
}

/**
 * PATCH /fees/:id
 * feeData: { name, display_name, amount, enabled, fee_type }
 */
export async function updateFee(feeId, feeData) {
  const res = await fetch(`${API_BASE_URL}/api/fees/${feeId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify({ fee: feeData })
  })
  if (!res.ok) {
    throw new Error(`Failed to update fee: ${res.status}`)
  }
  return res.json()
}

/**
 * DELETE /fees/:id
 */
export async function deleteFee(feeId) {
  const res = await fetch(`${API_BASE_URL}/api/fees/${feeId}`, {
    method: 'DELETE',
    headers: {
      ...getAuthHeaders()
    }
  })
  if (!res.ok) {
    throw new Error(`Failed to delete fee: ${res.status}`)
  }
}

/**
 * GET /fees/tax_classes
 */
export async function getTaxClasses() {
  const res = await fetch(`${API_BASE_URL}/api/fees/tax_classes`, {
    headers: {
      ...getAuthHeaders()
    }
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch tax classes: ${res.status}`)
  }
  return res.json()
}

/**
 * GET /fees/categories
 */
export async function getCategories() {
  const res = await fetch(`${API_BASE_URL}/api/fees/categories`, {
    headers: {
      ...getAuthHeaders()
    }
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch categories: ${res.status}`)
  }
  return res.json()
}

/**
 * GET /fees/products
 * params: { page, limit, search }
 */
export async function getProducts(params = {}) {
  const searchParams = new URLSearchParams()
  if (params.page) searchParams.append('page', params.page)
  if (params.limit) searchParams.append('limit', params.limit)
  if (params.search) searchParams.append('search', params.search)
  
  const url = `${API_BASE_URL}/api/fees/products${searchParams.toString() ? `?${searchParams.toString()}` : ''}`
  
  const res = await fetch(url, {
    headers: {
      ...getAuthHeaders()
    }
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch products: ${res.status}`)
  }
  return res.json()
}

/**
 * GET /fees/brands
 * params: { page, limit, search }
 */
export async function getBrands(params = {}) {
  const searchParams = new URLSearchParams()
  if (params.page) searchParams.append('page', params.page)
  if (params.limit) searchParams.append('limit', params.limit)
  if (params.search) searchParams.append('search', params.search)
  
  const url = `${API_BASE_URL}/api/fees/brands${searchParams.toString() ? `?${searchParams.toString()}` : ''}`
  
  const res = await fetch(url, {
    headers: {
      ...getAuthHeaders()
    }
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch brands: ${res.status}`)
  }
  return res.json()
}

/**
 * GET /fees/channels
 */
export async function getChannels() {
  const res = await fetch(`${API_BASE_URL}/api/fees/channels`, {
    headers: {
      ...getAuthHeaders()
    }
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch channels: ${res.status}`)
  }
  return res.json()
}

/**
 * GET /fees/customer_groups
 */
export async function getCustomerGroups() {
  const res = await fetch(`${API_BASE_URL}/api/fees/customer_groups`, {
    headers: {
      ...getAuthHeaders()
    }
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch customer groups: ${res.status}`)
  }
  return res.json()
}
